import React from "react";
import { Images } from "utils";
import { logoStyle } from "./styles";

export const GlobalLogo = ({widoutTextLogo}) => {
  const classes = logoStyle();

  return (
    <div className={classes.GlobalLogo}>
      <img src={widoutTextLogo ? Images.logoWidoutText : Images.logo} alt="tracker" />
    </div>
  );
};
